import 'app/validator'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import RemoteOrdersPage from 'app/features/orders/RemoteOrdersPage'

export default RemoteOrdersPage
